<template>
  <span>
    <b-button 
      :variant="variant"
      @click="execute"
      :size="size"
    >
      <template v-if="btnProcessing">
        <fa-icon icon="spinner" spin />
        &nbsp;
      </template>
      <slot>
      </slot>
    </b-button>
    <p v-if="displayedProcessingMessage">{{ displayedProcessingMessage }}</p>
  </span>
</template>

<script>

  export default {
    name: 'CButton',
    props: {
      onClick: Function,
      args: Object,
      variant: String,
      size: String,
      processingMessage: String,
      keepLoading: Boolean
    },
    data() {
      return {
        btnProcessing: false,
        displayedProcessingMessage: null
      }
    },
    created() {

    },
    watch: {

    },
    computed: {

    },
    methods: {
      async execute() {
        this.btnProcessing = true;
        this.displayedProcessingMessage = this.processingMessage;

        try {
          await this.onClick(this.args);

          if (!this.keepLoading) {
            this.displayedProcessingMessage = null;
            this.btnProcessing = false;
          }
        } catch(e) {
          if (!this.keepLoading) {
            this.displayedProcessingMessage = null;
            this.btnProcessing = false;
          }
        }
      },
    }
  }
</script>

<style scoped>

</style>
